import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  useTheme,
  Button,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { DotsIcon } from "../../../Svg";
import { makeStyles } from "@mui/styles";
import { format } from "date-fns";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdminToggleActiveIcon, AdminToggleInActiveIcon } from "../../../Svg";
import { AdminFormModal } from "../../../components";
import { headersGet, headersPost } from "../../../Services/API";
import { AdminUrls } from "../../../Services/Routes/API";
import { MainRoutes } from "../../../Services/Routes/App";
import { updateUserInAdmin } from "../../../Services/validation/AdminUser";

import DelModal from "../DelModal";

const UsersListing = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const headings = ["id", "User", "Email", "Date Created", "Status", ""];
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [updateUserModal, setUpdateUserModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [product, setProduct] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [api, setApi] = useState(false);
  const [userId, setUserId] = useState(null);

  const UserModalHandlerClose = () => {
    setUpdateUserModal(false);
  };

  const useStyles = makeStyles({
    muiPaperShadowNone: {
      "& .MuiPaper-root": {
        boxShadow: "1px 1px 0px 2px rgb(217 217 217)",
        minWidth: "100px",
      },
    },
    tableBodyText: {
      fontWeight: "400",
      fontSize: "13px",
      lineHeight: "20px",
      color: "#959595",
    },
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };
  const Form_Modal_List_For_Update_User = [
    {
      formKey: "user",
      name: "first_name",
      label: "First Name",
      value: userId?.first_name || "",
    },
    {
      formKey: "user",
      name: "last_name",
      label: "Last Name",
      value: userId?.last_name || "",
    },
    {
      formKey: "user",
      name: "email",
      label: "Enter Email",
      value: userId?.email || "",
    },
  ];
  const Form_Modal_Buttons_For_Update_User = [
    {
      text: "Update",
      name: "update",
      type: "submit",
      style: {
        backgroundColor: "#11A1EC",
        width: "100%",
        borderRadius: "1",
        padding: "1.5",
      },
    },
  ];

  const getAdminUsers = () => {
    setOpen(true);
    headersGet(AdminUrls.GET_USERS_LISTING)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setUsers(res?.data?.users);
          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getAdminUsers();
  }, [api]);

  // Status Toggle
  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const delProduct = (pro) => {
    setProduct(pro);
    setOpenModal(true);
  };
  const userStatusHandler = () => {
    const data = {
      user: {
        id: product?.id,
        is_blocked: !product?.is_blocked,
      },
    };
    setOpen(true);

    headersPost(AdminUrls.USER_STATUS, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const updateUserData = (item) => {
    setUserId(item);
    setUpdateUserModal(true);
  };

  const updateUserHandler = (data) => {
    setOpen(true);
    headersPost(AdminUrls?.UPDATE_USER, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setUpdateUserModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const classes = useStyles();

  return (
    <Box mt={6}>
      <Paper>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 650, height: "200px" }}
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              {" "}
              <TableRow>
                {headings?.map((h, index) => {
                  {
                    return (
                      <TableCell
                        sx={{ fontWeight: "bold" }}
                        key={`${index}-table-heading-${h}`}
                      >
                        {h}
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {users?.map((row, index) => (
                <TableRow key={`${index}-row.name-${index + 2}`}>
                  <TableCell className={classes.tableBodyText}>
                    {row?.id}{" "}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.first_name} {row?.last_name}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.email}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.created_at
                      ? format(new Date(row?.created_at), "MM/dd/yyyy hh:mm")
                      : ""}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    <Button
                      variant="none"
                      onClick={() => delProduct(row)}
                      size="small"
                      sx={{
                        padding: theme.spacing(0),
                        minWidth: "35px",
                        borderRadius: 3,
                      }}
                    >
                      {row?.is_blocked ? (
                        <AdminToggleInActiveIcon />
                      ) : (
                        <AdminToggleActiveIcon />
                      )}
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      // id={`basic-button-${row?.id}`}
                      // aria-haspopup="true"
                      onClick={() => updateUserData(row)}
                      sx={{
                        borderRadius: 1,
                        minWidth: 0,
                        backgroundColor: "white",
                        padding: 1,
                        color: "#828282",
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </Button>
                    {/* <Menu
                      id={`basic-menu-${row?.id}`}
                      className={classes.muiPaperShadowNone}
                      anchorEl={anchorEl}
                      open={anchorEl?.id === `basic-button-${row?.id}`}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem>
                        <ListItemIcon>
                          {" "}
                          <EditIcon />
                        </ListItemIcon>
                        <ListItemText onClick={() => updateUserData(row)}>
                          Edit
                        </ListItemText>
                      </MenuItem>
                      <MenuItem>
                        <ListItemIcon>
                          {" "}
                          <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                      </MenuItem>
                    </Menu> */}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <AdminFormModal
        open={updateUserModal}
        onClose={UserModalHandlerClose}
        MainHeading={"Update User"}
        TextFieldArray={Form_Modal_List_For_Update_User}
        ButtonsArray={Form_Modal_Buttons_For_Update_User}
        initialFormData={{
          user: {
            id: userId?.id,
          },
        }}
        onSubmit={updateUserHandler}
      />
      <DelModal
        header={"Status"}
        status={product?.is_blocked}
        open={openModal}
        handleClose={closeModalHandler}
        statusHandler={userStatusHandler}
      />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UsersListing;
